import { SelectPlus } from 'Components/SelectPlus';
import { useGetDepartments } from '../hooks/useDepartments';
import { getErrorMessage } from '@/shared/utils/errors/getErrorMessage';

export const SelectDepartment = ({ mode = 'single', valueKey = 'id', ...selectProps }) => {
  // Se cargan todos los departamentos
  const { data, isFetching, isError, error } = useGetDepartments({ pageSize: 40 });

  const isSingleMode = mode === 'single';
  const placeholder = `Seleccionar departamento${isSingleMode ? '' : 's'}`;

  const records = data?.results ?? [];
  const options = records.map((record) => ({
    value: record[valueKey],
    label: record.name,
    record,
  }));

  return (
    <SelectPlus
      mode={mode}
      placeholder={placeholder}
      loading={isFetching}
      options={options}
      error={isError}
      errorMessage={getErrorMessage(error)}
      {...selectProps}
    />
  );
};
